
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/transfer/metrics",
      function () {
        return require("private-next-pages/docs/api/products/transfer/metrics.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/transfer/metrics"])
      });
    }
  